import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module_next_project';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.id = false;

		if ( this.$el.length > 0 ){
			setTimeout( ()=>{
				this.init();
			}, 1000 );


		}
    }

    init(){
    	this.addEvents( true );
    	this.modifyDomPosition( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( this.$el.hasClass( 'has-image' ) ){
			if ( b ){
				this.$el.find( 'a' ).on( 'click', ()=>this.fadeOut(true) );
			}
			else{
				this.$el.find( 'a' ).off( 'click', ()=>this.fadeOut(true) );
			}
		}
	}

    //---------------------------------------- METHODS ---------------------------------------//
	modifyDomPosition( b ){

		//console.log( 'modifyDomPosition, b = ' + b );
		

		if ( b ){
			if ( this.$el.hasClass( 'has-image' ) ){

				$( 'main' ).addClass( 'has-image-next-project' );
				if ( this.$el.find( '.img-next-project' ).length > 0 ){
					let id = 'next-project-appended', $img_next;
					if ( $( '#' + id ).length > 0 ){
						$( '#' + id ).remove();
					}
					$img_next = this.$el.find( '.img-next-project' ).appendTo( 'body' );
					this.id = id;
					$img_next.attr( 'id', this.id );
				}
			}			
		}
		else{
			//console.log( 'hello' );
			if ( this.$el.hasClass( 'has-image' ) ){
				$( 'main' ).removeClass( 'has-image-next-project' );
				if ( this.id ){
					if ( $( '#' + this.id ).length > 0 ){
						$( '#' + this.id ).remove();
					}
				}
			}
		}
	}

	fadeOut( b ){
		if ( b ){
			gsap.to( $( '.img-next-project' ), {opacity:0, duration: this.main.options.time_fade_out, ease: 'power3.easeOut', onComplete:()=>this.modifyDomPosition( false ) } );
		}
		else{
			// NADA
		}
	}

    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );

    		// THIS IS CALLES AFTER FADE OUT!!!!
    		//this.modifyDomPosition( false );
    	}
    }

}


